import React from 'react'
import {connect} from 'react-redux'
import HandsonTable from '../components/HandsonTable'
import {MarkerList} from '../config'

import {BoltKeyMap} from '../utils/table'

const LogbookReboltReport = React.createClass({
  displayName: 'LogbookReboltReport',
  nestedHeaders: [
  ['','','','',{ label: '工作項目', colspan: 4 },''],
  ['測試日期','編號','路線','Bolt','Bolt類型','洗洞','鑽洞','設置','移除','施工人員'],
  ],
  columns: [
  { data: 'date', readOnly: true, width:100},
  { data: 'rid', readOnly: true, width:60},
  { data: 'name', readOnly: true, width:100},
  { data: 'bid', readOnly: true, width:60},
  { data: 'type', readOnly: true, width:120},
  { data: 'core', readOnly: true, type: 'checkbox', width:100},
  { data: 'hole', readOnly: true, type: 'checkbox', width:100},
  { data: 'bolt', readOnly: true, type: 'checkbox', width:100},
  { data: 'removal', readOnly: true, type: 'checkbox', width:100},
  { data: 'worker', readOnly: true, width:200},
  ],

  render() {
    let styles = {
      table:{
        margin:20,
        overflow:'auto',
        height:'100%',
      },
    }

    return (
      <HandsonTable
      ref="table"
      style={styles.table}
      autoUpdate={true}
      nestedHeaders={this.nestedHeaders}
      columns={this.columns}
      data={this.props.list}
      />
      )
  },
})

function mapStateToProps(state,props) {
  let { routes,tasks } = state
  let list = []
  Object.keys(tasks).reverse().forEach(date=>{
    let report = tasks[date]
      Object.keys(report).forEach(id=>{
        let task = {...report[id]}
        task.date = date
        let route = routes[task.rid]
        if(route){
          task.name = route.name
        }
        task.type = BoltKeyMap[task.type]

        list.push(task)
      })
  })

  return {list}
}


export default connect(mapStateToProps)(LogbookReboltReport)



/** WEBPACK FOOTER **
 ** ./src/app/containers/LogbookReboltReport.js
 **/